var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRearParkingSensor24 = function SvgRearParkingSensor24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.088 6h1.824a3.2 3.2 0 0 1 2.183.845c.58.54.905 1.275.905 2.04v6.691c0 .319-.067.634-.197.928a2.42 2.42 0 0 1-.563.786c-.24.225-.527.404-.841.526a2.754 2.754 0 0 1-.993.184h-2.812c-.34 0-.678-.063-.992-.184a2.602 2.602 0 0 1-.842-.526 2.42 2.42 0 0 1-.563-.786A2.285 2.285 0 0 1 8 15.576v-6.69c0-.38.08-.754.235-1.104a2.88 2.88 0 0 1 .67-.936c.286-.268.627-.48 1.001-.625.375-.145.776-.22 1.182-.22v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.978 9h2.044c.79 0 1.547.249 2.106.691.558.443.872 1.043.872 1.67v1.993a.586.586 0 0 1-.239.457.933.933 0 0 1-.575.189H8.813a.933.933 0 0 1-.575-.19.586.586 0 0 1-.239-.456V11.36c0-.626.314-1.226.872-1.669C9.431 9.25 10.188 9 10.978 9v0ZM8 10H6m12 0h-2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.961V6.526c0-1.2.486-2.352 1.35-3.2A4.652 4.652 0 0 1 7.609 2h8.782c1.223 0 2.395.477 3.26 1.326.863.848 1.349 2 1.349 3.2v9.948c0 1.2-.486 2.352-1.35 3.2A4.652 4.652 0 0 1 16.391 21H11m-4 2H5.631a4.563 4.563 0 0 1-3.275-1.397A4.845 4.845 0 0 1 1 18.229V17m6 3h-.684a2.28 2.28 0 0 1-1.632-.695A2.44 2.44 0 0 1 4 17.619V17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRearParkingSensor24;